import Tooltip from '@mui/material/Tooltip';
import { Icon } from '@sdb/planning-ui';

type Props = {
  warning?: boolean;
  message: string;
};

export default function InfoCell({ warning, message = '' }: Props) {
  return (
    <td className="info-cell">
      <Tooltip title={message} arrow disableInteractive>
        <Icon
          type={warning ? 'circle-exclamation' : 'info'}
          fontSize="small"
          color={warning ? 'warning' : 'primary'}
          className="info-icon"
        />
      </Tooltip>
    </td>
  );
}
